/*
 * @ Author: wangjiyu
 * @Date: 2020-04-10 11:54:38
 * @LastEditTime: 2020-04-13 16:59:06
 * @LastEditors: wangjiyu
 * @Description: file content
 */

import AddTitleDialog from './addTitleDialog';

export default AddTitleDialog;
